export const COLOR_PRIMARY = "#e91e63";
export const COLOR_SECONDARY = "#FFFFFF";
export const COLOR_TERTIARY = "#8C9AA5";
export const COLOR_QUATERNARY = "#8C9AA5";
export const COLOR_QUINARY = "#EEEEEE";